import React, { useMemo } from "react";

import { Text, View, StyleSheet } from "@react-pdf/renderer";

import { ReportQuestionEntryProps } from "../ReportQuestion";
import {
  parseQuestion,
  parseAnswers,
} from "../../../reports/TemplateQuestionsImpl/TemplateQuestionTextLong";
import { getReportAnswersByRole } from "../../../reports/TemplateQuestion";

import ReportQuestionTitle from "./utils/ReportQuestionTitle";
import ReportAnswerPDF from "./utils/ReportAnswer";

const styles = StyleSheet.create({
  answerGroupContainer: {
    paddingHorizontal: "4mm",
    paddingBottom: "3mm",
    marginVertical: "1.5mm",
  },
  answerGroupHeader: {
    fontSize: "3.7mm",
    color: "#2b3e54",
  },
  answerGroup: {
    paddingTop: "3mm",
  },
});

const ReportQuestionTextLong: React.FC<ReportQuestionEntryProps> = ({
  mad: mad,
  question: rawQuestion,
  answers: rawAnswers,
  index,
  t,
}) => {
  const question = useMemo(() => parseQuestion(rawQuestion), [rawQuestion]);
  const answers = useMemo(
    () => getReportAnswersByRole(rawAnswers, parseAnswers, mad),
    [rawAnswers]
  );

  const timeSpent = useMemo(() => {
    let tSpent = 0;

    answers.referent.forEach((a) => (tSpent += a.timeSpent));
    return Math.floor(tSpent / answers.referent.length);
  }, [answers]);

  return (
    <View>
      <ReportQuestionTitle
        title={question.label}
        questionDescription={question.description}
        timeSpent={question.timeTracked ? timeSpent : undefined}
        description={t("reports.textLongQuestion") as string}
        index={index + 1}
      />
      <View style={styles.answerGroupContainer}>
        <Text style={styles.answerGroupHeader}>
          {t("reports.talentAnswer")}
        </Text>
        <View style={styles.answerGroup}>
          {answers.talent.map((a) => (
            <ReportAnswerPDF
              answer={a}
              answerAs={<Text>{a.value}</Text>}
              key={a.id}
              t={t}
            />
          ))}
        </View>
      </View>
      <View style={styles.answerGroupContainer}>
        <Text style={styles.answerGroupHeader}>
          {t("reports.evaluatorsAnswers", { count: answers.referent.length })}
        </Text>
        <View style={styles.answerGroup}>
          {answers.referent.map((a) => (
            <ReportAnswerPDF
              answer={a}
              answerAs={<Text>{a.value}</Text>}
              key={a.id}
              t={t}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

export default ReportQuestionTextLong;
